"use client";

import React from "react";
import cx from "classnames";
import { usePrevious } from "react-use";

// https://www.toptal.com/designers/subtlepatterns/white-waves-pattern/
// https://www.toptal.com/designers/subtlepatterns/vintage-concrete/
// https://www.toptal.com/designers/subtlepatterns/ep-natural-white/
// https://www.toptal.com/designers/subtlepatterns/subtle-grey/
// https://www.toptal.com/designers/subtlepatterns/light-paper-fibers/
// https://www.toptal.com/designers/subtlepatterns/wall-4-light/
// https://www.toptal.com/designers/subtlepatterns/white-wall/
// https://www.toptal.com/designers/subtlepatterns/hexellence/
// https://www.toptal.com/designers/subtlepatterns/white-leather-2/
// https://www.toptal.com/designers/subtlepatterns/transparent-square-tiles/
// https://www.toptal.com/designers/subtlepatterns/bright-squares/
// https://www.toptal.com/designers/subtlepatterns/subtle-freckles/
// https://www.toptal.com/designers/subtlepatterns/rocky-wall/
const ExtendNav = ({
  children,
  duration = 500,
  isOpen = false,
  contentContainerClass = "",
  backdropClass = "",
  wrapperClass = "",
  alwaysRender = true,
  theme = "dark",
  afterOpen = () => {},
}) => {
  const [childrenVisible, setChildrenVisible] = React.useState(false);
  const prevIsOpen = usePrevious(isOpen);

  React.useEffect(() => {
    if (!prevIsOpen && isOpen) {
      setChildrenVisible(true);
      afterOpen();
    }

    if (prevIsOpen && !isOpen) {
      setTimeout(() => {
        setChildrenVisible(false);
      }, duration);
    }
  }, [duration, prevIsOpen, isOpen, afterOpen]);

  return (
    <div
      className={cx("fixed top-0 left-0 right-0 h-screen w-screen z-40", wrapperClass, {
        "pointer-events-auto": isOpen,
        "pointer-events-none": !isOpen,
      })}
    >
      <div
        className={cx(
          `absolute inset-0 transition duration-${duration} ease-in-out z-40`,
          backdropClass,
          {
            "backdrop-blur-xs bg-black/75": isOpen,
            "backdrop-blur-none bg-black/0": !isOpen,
          },
        )}
      ></div>
      <div
        className={cx(
          `relative transition-[height] overflow-hidden duration-${duration} ease-in-out z-50`,
          {
            "h-screen": isOpen,
            "h-0": !isOpen,
          },
        )}
      >
        <div
          className={cx("relative h-screen", {
            "bg-neutral-900": theme === "dark",
            "bg-white": theme === "light",
          })}
        >
          <div className={cx("px-4 pointer-events-auto", contentContainerClass)}>
            {alwaysRender || childrenVisible ? children : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtendNav;
